import React from "react";
import styled from "styled-components";
import { Card, Colors, Intent, Tag } from "@blueprintjs/core";
import { Box } from "ui-components";

type Props = {
  className?: string;
  interactive?: boolean;
  verticle?: boolean;
  avatarIcon?: string;
  chipLabel?: string;
  chipStatus?: Intent;
  children: React.ReactNode;
  imageWidth?: string;
};
const HorizontalCard = (props: Props) => {
  const {
    className = "",
    interactive = false,
    verticle = false,
    avatarIcon,
    chipLabel = null,
    chipStatus = "success",
    children = null,
    imageWidth = "50",
  } = props;
  return (
    <CustomCard className={className} interactive={interactive}>
      <Box flexDir={verticle ? "col" : "row"} items="start">
        {avatarIcon && (
          <div className="mr-sm">
            <CustomAvatar src={avatarIcon} alt="" width={imageWidth} />
          </div>
        )}
        <TextContainer>{children}</TextContainer>
      </Box>
      {chipLabel && (
        <Chip>
          <Tag round={true} large={true} intent={chipStatus} minimal={true}>
            {chipLabel}
          </Tag>
        </Chip>
      )}
    </CustomCard>
  );
};

export default HorizontalCard;

const CustomAvatar = styled.img`
  width: 60px;
  height: auto;

  @media (min-width: 993px) and (max-width: 1380px) {
    width: 50px;
  }

  @media (max-width: 992px) {
    width: 40px;
  }
`;
const Chip = styled.span`
  float: right;
  margin-right: 5px;
  margin-top: -15px;
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.GRAY4 : Colors.GRAY2};
`;

const CustomCard = styled(Card)`
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
  width: 100%;
  @media (min-width: 1511px) {
    padding-right: 30px !important;
    padding-left: 30px !important;
  }
  @media (min-width: 1281px) and (max-width: 1520px) {
    padding-right: 22px !important;
    padding-left: 22px !important;
  }
  @media (min-width: 993px) and (max-width: 1280px) {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
  @media (max-width: 992px) {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
`;

export const Amount = styled.span`
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  @media (min-width: 1351px) and (max-width: 1450px) {
    font-size: 22px;
  }
  @media (min-width: 993px) and (max-width: 1350px) {
    font-size: 20px;
  }

  @media (max-width: 992px) {
    font-size: 18px;
  }
`;

export const Label = styled.span`
  font-size: 15px;
  white-space: nowrap;
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.GRAY5 : Colors.GRAY1};
  // line-height: 1.7em;
  margin-top: 3px;
  @media (min-width: 993px) and (max-width: 1380px) {
    font-size: 14px;
  }

  @media (max-width: 992px) {
    font-size: 12px;
  }
`;
